// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SearchBar_wrapper__2Opt","addon":"SearchBar_addon__3rMp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/SearchBar/SearchBar.scss
// module id = 579
// module chunks = 0